import { render, staticRenderFns } from "./CheckoutCartBox.vue?vue&type=template&id=5ffa028d&scoped=true"
import script from "./CheckoutCartBox.vue?vue&type=script&lang=js"
export * from "./CheckoutCartBox.vue?vue&type=script&lang=js"
import style0 from "./CheckoutCartBox.vue?vue&type=style&index=0&id=5ffa028d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa028d",
  null
  
)

export default component.exports